import { Action } from 'redux';
import { Billings, Pagination } from 'src/types/model';

export const FETCH_BILLING_REQUEST = 'FETCH_BILLING_REQUEST';
export const FETCH_BILLING_SUCCESS = 'FETCH_BILLING_SUCCESS';
export const FETCH_BILLING_FAILURE = 'FETCH_BILLING_FAILURE';

export interface FetchBILLINGRequestAction
  extends Action<typeof FETCH_BILLING_REQUEST> {}

export interface FetchBILLINGSuccessAction
  extends Action<typeof FETCH_BILLING_SUCCESS> {
  payload: {
    data: Billings[];
    pagination: Pagination;
  };
}

export interface FetchBILLINGFailureAction
  extends Action<typeof FETCH_BILLING_FAILURE> {
  payload: string;
}

export type BillingActionType =
  | FetchBILLINGRequestAction
  | FetchBILLINGSuccessAction
  | FetchBILLINGFailureAction;
